import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-648297ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booking-controls -mb-2 mr-2" }
const _hoisted_2 = { class: "field inline-block legend-area ml-2" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "field-checkbox"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "show_free_space",
  class: "ml-2"
}, "自由予約を表示", -1))
const _hoisted_7 = {
  key: 0,
  class: "week-header"
}
const _hoisted_8 = { class: "date block" }
const _hoisted_9 = { class: "date-number mr-1" }
const _hoisted_10 = { class: "date-text" }
const _hoisted_11 = {
  key: 0,
  class: "font-lms-regular-13"
}
const _hoisted_12 = {
  key: 0,
  class: "absolute ml-3"
}
const _hoisted_13 = { class: "m-1" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }

import {
  ref,
  withDefaults,
  onUpdated,
  onMounted,
  onUnmounted,
  computed,
  /* inject, */ watch,
  nextTick,
} from "vue";
import { useStore } from "vuex";
import FullCalendar from "@fullcalendar/vue3";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import interactionPlugin from "@fullcalendar/interaction";
import Checkbox from "primevue/checkbox";
import { IBookingPickedTime, IBookingsCalendarOptions /* IClinicBusinessDaySetting */ } from "@/clinic/typings";
import { AnyFn, get, set, templateRef /* useArrayReduce, useDateFormat */ } from "@vueuse/core";
import moment from "moment";
import Timeline from "./template/timeline.vue";
import DayEventTemplate from "./template/events/day.vue";
import WeekEventTemplate from "./template/events/week/index.vue";
import EventTooltipTemplate from "./template/events/tooltip.vue";
import DayOfWeek from "@/clinic/utils/day-of-week-utils";
import {
  DateSelectArg,
  DatesSetArg,
  EventChangeArg,
  EventContentArg,
  EventSourceFuncArg,
  /* SlotLaneContentArg, */
} from "@fullcalendar/core";
import {
  BookingViewTypeEnum,
  BookingViewTypeSlotDurationEnum,
  BookingStatusColorClass,
  BookingSourceColorClasses,
  BookingStatusColorOptions,
} from "@/clinic/typings/enums/booking";
import { dayOfWeekShort } from "@/clinic/typings/enums/day-of-week";
import {
  /* CALENDAR_RESOURCE_HEIGHT,
  CALENDER_RESOURCES_COUNT,
  MILLISECONDS_IN_HOUR, */
  MILLISECONDS_IN_DAY,
  MILLISECONDS_MIN_SLOT_DEFAULT,
  MILLISECONDS_MAX_SLOT_DEFAULT,
} from "@/clinic/typings/constants/booking";
import { WeekDayEnum } from "@/clinic/typings/enums/clinic";
import _ from "lodash";
import { ClinicBusinessDaySettingService } from "@/clinic/services";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

type IBodyCalendar = {
  pickedDate: IBookingPickedTime;
  viewType: string;
  clinicId: number;
  height: number;
  slotDuration: string;
  refreshClinicBusinessDaySetting: Date;
  remainingSlots: Array<number>;
  showFreeSpace?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'body',
  props: {
    pickedDate: null,
    viewType: { default: BookingViewTypeEnum.Day },
    clinicId: { default: 0 },
    height: null,
    slotDuration: { default: "" },
    refreshClinicBusinessDaySetting: null,
    remainingSlots: { default: () => [] },
    showFreeSpace: { type: Boolean }
  },
  emits: [
  "select",
  "changeDate",
  "eventChange",
  "resourcesFn",
  "eventsFn",
  "showDialogStaffTimeOff",
  "toggleFreeSpace",
],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { pickedDate: IBookingPickedTime, viewType: string, clinicId: number, height: number, slotDuration: string, refreshClinicBusinessDaySetting: Date, remainingSlots: Array<number>, showFreeSpace?: boolean };

const store = useStore();

const isClinicUnaffiliated = () => {
  return store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated;
};

const refetchCalendarResources = () => get(bookingCalendar).getApi().refetchResources();



const currentStartDate = ref(props.pickedDate?.start);
const clinicDaySetting = ref();

// 基本設定から制御フラグを取得
const bookingSettings = computed(() => store.state.bookingSetting?.bookingSetting);
const isShowFreeSpaceEnabledInSettings = computed(() => bookingSettings.value?.show_free_space !== false);

// 初期値を基本設定も考慮して決定
const showFreeSpaceBooking = ref(
  isShowFreeSpaceEnabledInSettings.value && (props.showFreeSpace !== undefined ? props.showFreeSpace : true)
);

// 親コンポーネント(index.vue)のshowFreeSpace(useStorageで永続化)の変更を監視
watch(
  () => props.showFreeSpace,
  newValue => {
    if (isShowFreeSpaceEnabledInSettings.value) {
      // 基本設定でONの場合のみ、propsの値を反映
      showFreeSpaceBooking.value = newValue ?? true;
    } else {
      // 基本設定でOFFの場合は強制的にfalse
      showFreeSpaceBooking.value = false;
    }
  }
);



const onSelect = (event: DateSelectArg) => {
  if (isClinicUnaffiliated()) {
    emits("select", event);
  }
};

const slotDuration = computed((): string => {
  const duration =
    props.viewType == BookingViewTypeEnum.Week ? BookingViewTypeSlotDurationEnum.Week : props.slotDuration;
  return duration;
});

const slotLabelClassNames = (): string => {
  return `slot-frame-${props.viewType.toLowerCase()}`;
};

const hasWeekViewType = computed((): boolean => props.viewType == BookingViewTypeEnum.Week);

const onChangeDate = (event: DatesSetArg) => {
  emits("changeDate", event);

  const api = get(bookingCalendar).getApi();
  api?.setOption("viewClassNames", get(viewClassName));
  api?.setOption("defaultAllDay", get(hasWeekViewType));
  if (props.viewType == BookingViewTypeEnum.Week) {
    api.setOption("firstDay", WeekDayEnum.monday);
    api?.setOption("slotDuration", "24:00:00");
    api?.setOption("slotLabelInterval", "24:00:00");
  } else {
    api?.setOption("slotDuration", get(slotDuration));
    api?.setOption("slotLabelInterval", get(slotDuration));
  }

  get(bookingCalendar).getApi().removeAllEvents();
  get(bookingCalendar).getApi().refetchEvents();
};

const onEventChange = (event: EventChangeArg) => {
  emits("eventChange", event);

  // イベント変更後にフリースペースレーンの高さを調整
  nextTick(() => {
    setTimeout(() => {
      adjustFreeSpaceLaneHeights();
    }, 100); // DOM更新を待つ
  });
};

const getResourceView = (viewType: string) => `resourceTimeline${viewType}`;
const viewClassName = computed((): string => `view-type-${props.viewType.toLowerCase()}`);

const eventClassNames = ({
  event: {
    extendedProps: { medicalMenuId, status, bookingType, bookingSource, hotpepperConfirmed },
  },
}: EventContentArg): string => {
  const viewType = props.viewType.toLowerCase();
  const backgroundClass = backgroundEventClass(status, bookingType, bookingSource, hotpepperConfirmed);
  return `event-medical-${medicalMenuId} event-${viewType} ${backgroundClass} border-none`;
};

/**
 * イベントの背景色クラスを取得する（旧イベント情報用）
 *
 * @description
 * 予約カレンダーのイベントカードに適用する背景色クラスを返す。
 * 新しいカードデザイン適用のため、旧デザインの背景色（bg-will-come等）を
 * 使用せず、空文字列を返して背景を透明にする。
 *
 * 実際の背景色の透明化は、グローバルスタイルの`:global(.fc-event)`等で
 * `background-color: transparent !important`を適用することで実現している。
 *
 * @param {string} status - 予約ステータス（will_come, booked, completed等）
 * @param {string} bookingType - 予約タイプ（normal, request等）
 * @param {string} bookingSource - 予約ソース（hotpepper, line, instagram等）
 * @param {string} hotpepperConfirmed - ホットペッパー予約の確認状態
 * @returns {string} 背景色CSSクラス名（空文字列 = 背景色なし）
 *
 * @see グローバルスタイル（行1171-1178）で背景色を透明化
 * @see BookingStatusColorClass - 旧デザインのステータス別カラークラス定義
 * @see BookingSourceColorClasses - 旧デザインの予約ソース別カラークラス定義
 */
const backgroundEventClass = (
  status: string,
  bookingType: string,
  bookingSource: string,
  hotpepperConfirmed: string
): string => {
  return "";
};

// const getResourceType = (resource: string): string => resource.replace("resourceTimeline", "");

const resourceLabelClassNames = (resource: EventSourceFuncArg): string => {
  const {
    resource: {
      _resource: { extendedProps },
    },
  } = resource;
  const { default_staff } = extendedProps;
  if (default_staff) {
    return "text-red-500";
  } else {
    return "text-black-alpha-90";
  }
};

const resourceLabelDidMount = (info: { resource: { id: string; title: string }; el: HTMLElement }) => {
  if (isClinicUnaffiliated()) {
    const buttonContainer = document.createElement("div");
    Object.assign(buttonContainer.style, {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    });

    buttonContainer.appendChild(buttonSelectSpecialShifts(info.resource));

    const elStyle = info.el.style;
    Object.assign(elStyle, {
      display: "flex",
      justifyContent: "space-between",
      borderTop: "none",
      borderRight: "none",
      borderLeft: "none",
    });

    info.el.appendChild(buttonContainer);
  }
};

const buttonSelectSpecialShifts = (data: { id: string; title: string }) => {
  const icon = document.createElement("i");
  icon.className = "pi pi-calendar-times cursor-pointer mr-2";
  icon.addEventListener("click", () => showDialogStaffTimeOff(data));
  return icon;
};

const showDialogStaffTimeOff = (data: { id: string; title: string }) => emits("showDialogStaffTimeOff", data);

let listStaffsPromise;
let pendingStaffsRequest = 0;

const resources = (source, onSuccess, onError) => {
  if (!listStaffsPromise) {
    listStaffsPromise = new Promise(resolve => {
      pendingStaffsRequest++;
      const customOnSuccess = data => {
        resolve(data);

        if (onSuccess) {
          onSuccess(data);
        }

        pendingStaffsRequest--;
        if (pendingStaffsRequest === 0) {
          listStaffsPromise = null;
        }
      };

      emits("resourcesFn", {
        ...source,
        viewType: props.viewType,
        onSuccess: customOnSuccess,
        onError,
      });
    });
  }

  listStaffsPromise
    .then(data => {
      if (onSuccess) {
        onSuccess(data);
      }
    })
    .catch(error => {
      console.error("Error occurred:", error);
      if (onError) {
        onError(error);
      }
    });
};

let listBookingsPromise;
let listBookingPendingRequests = 0;
const events = (event: EventSourceFuncArg, onSuccess: AnyFn, onError: AnyFn) => {
  if (!listBookingsPromise) {
    listBookingsPromise = new Promise(resolve => {
      listBookingPendingRequests++;
      const customOnSuccess = data => {
        resolve(data);

        if (onSuccess) {
          onSuccess(data);
        }

        listBookingPendingRequests--;
        if (listBookingPendingRequests === 0) {
          listBookingsPromise = null;
        }
      };

      emits("eventsFn", { ...event, onSuccess: customOnSuccess, onError, pickedDate: currentStartDate.value });
    });
  }

  listBookingsPromise
    .then(data => {
      if (onSuccess) {
        onSuccess(data);
      }
    })
    .catch(error => {
      if (onError) {
        onError(error);
      }
    });
};

const slotMinTimeMilliseconds = computed((): number => {
  if (isClinicUnaffiliated()) {
    if (_.isEmpty(get(clinicDaySetting)) || get(props.viewType) == BookingViewTypeEnum.Week) return 0;
    const dayOfWeekNum = moment(props.pickedDate.start).weekday();
    const dayOfWeek = DayOfWeek.getDayOfWeekByNumber(parseInt(dayOfWeekNum));
    const totalMilliseconds = get(convertTimeToMilliseconds(get(clinicDaySetting)[`${dayOfWeek}_morning_start`]));
    return totalMilliseconds || MILLISECONDS_MIN_SLOT_DEFAULT;
  } else {
    return MILLISECONDS_MIN_SLOT_DEFAULT;
  }
});

const slotMinTime = computed((): { millisecond: number } => ({ millisecond: get(slotMinTimeMilliseconds) }));

const slotMaxTimeMilliseconds = computed((): number => {
  if (isClinicUnaffiliated()) {
    if (_.isEmpty(get(clinicDaySetting)) || get(props.viewType) == BookingViewTypeEnum.Week) return MILLISECONDS_IN_DAY;
    const dayOfWeekNum = moment(props.pickedDate.start).weekday();
    const dayOfWeek = DayOfWeek.getDayOfWeekByNumber(parseInt(dayOfWeekNum));
    const startDayMilliseconds = get(convertTimeToMilliseconds(get(clinicDaySetting)[`${dayOfWeek}_morning_start`]));
    const endDayMilliseconds = get(convertTimeToMilliseconds(get(clinicDaySetting)[`${dayOfWeek}_afternoon_end`]));
    const totalMilliseconds = endDayMilliseconds - startDayMilliseconds;
    const durationMilliseconds = get(convertTimeToMilliseconds(get(slotDuration)));
    const roundingNumber = Math.ceil(totalMilliseconds / durationMilliseconds);
    return totalMilliseconds
      ? roundingNumber * durationMilliseconds + startDayMilliseconds
      : MILLISECONDS_MAX_SLOT_DEFAULT;
  } else {
    return MILLISECONDS_MAX_SLOT_DEFAULT;
  }
});

const slotMaxTime = computed((): { millisecond: number } => ({ millisecond: get(slotMaxTimeMilliseconds) }));

const convertTimeToMilliseconds = (timeString: string) => {
  if (!timeString) return 0;

  const [hours = "0", minutes = "0", seconds = "0"] = timeString.split(":").map(part => parseInt(part, 10));

  return ((parseInt(hours, 10) * 60 + parseInt(minutes, 10)) * 60 + parseInt(seconds, 10)) * 1000;
};

/**
 * イベント要素がマウントされた直後に呼ばれるコールバック
 * インラインスタイルで即座に背景を透明化し、初回ロード時の旧デザイン表示を防ぐ
 * @param info - イベント情報とDOM要素
 */
const eventDidMount = (info: { el: HTMLElement; event: any }) => {
  // FullCalendarのデフォルト背景を即座に透明化
  info.el.style.backgroundColor = "transparent";
  info.el.style.background = "transparent";
  info.el.style.borderColor = "transparent";
};

const calendarOptions = ref<IBookingsCalendarOptions>({
  schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
  timeZone: "local",
  plugins: [resourceTimelinePlugin, interactionPlugin],
  initialView: getResourceView(props.viewType),
  initialDate: props.pickedDate?.start,
  events,
  resourceOrder: "-default_staff",
  refetchResourcesOnNavigate: true,
  resources,
  resourceAreaWidth: 200,
  resourceLabelClassNames,
  slotMinWidth: 300,
  height: "auto",
  slotEventOverlap: false,
  editable: false,
  eventStartEditable: false,
  eventDurationEditable: false,
  eventResourceEditable: false,
  resourceAreaHeaderContent: "",
  nowIndicator: true,
  slotDuration: get(slotDuration),
  slotLabelInterval: get(slotDuration),
  headerToolbar: false,
  selectable: true,
  defaultAllDay: get(hasWeekViewType),
  select: onSelect,
  datesSet: onChangeDate,
  eventChange: onEventChange,
  viewClassNames: get(viewClassName),
  eventClassNames,
  slotLabelClassNames,
  slotMinTime: get(slotMinTime),
  slotMaxTime: get(slotMaxTime),
  snapDuration: get(slotDuration),
  resourceLabelDidMount: resourceLabelDidMount,
  eventDidMount: eventDidMount,
});

const bookingCalendar = templateRef<InstanceType<typeof FullCalendar>>("bookingCalendar", null);

const applyEditableOptions = () => {
  const api = get(bookingCalendar)?.getApi();
  if (!api) return;

  const canDrag = isClinicUnaffiliated();

  api.setOption("editable", canDrag);
  api.setOption("eventStartEditable", canDrag);
  api.setOption("eventDurationEditable", canDrag);
  api.setOption("eventResourceEditable", canDrag);

  api.removeAllEvents();
  api.refetchEvents();
};

watch(
  () => store.getters["authClient/selectedClinic"]?.partner,
  partner => {
    if (partner === undefined) return;
    applyEditableOptions();
  },
  { immediate: true }
);

const loadEvents = () => {
  // propsの日付でcurrentStartDateを更新（ビュータイプ切り替え時に必要）
  if (props.pickedDate?.start) {
    currentStartDate.value = props.pickedDate.start;
  }

  // Promiseキャッシュをリセットして新しい日付で確実にAPIリクエストを実行
  listBookingsPromise = null;
  listBookingPendingRequests = 0;

  const api = get(bookingCalendar)?.getApi();
  if (api) {
    api.removeAllEvents();
    api.refetchEvents();
  }
};

const totalCustomersBooked = ref({});

const setTotalCustomersBooked = data => {
  set(totalCustomersBooked, data);
};

const loadDate = () => {
  const { start } = props.pickedDate;
  if (start && start.getTime() != get(bookingCalendar)?.getApi().getDate().getTime()) {
    get(bookingCalendar)?.getApi().gotoDate(start);
  }
};

let promiseClinicDaySetting;
const loadClinicDaySetting = () => {
  const { start } = props.pickedDate;
  const clinicId = props.clinicId;

  if (clinicId && start) {
    if (!promiseClinicDaySetting) {
      promiseClinicDaySetting = new Promise((resolve, reject) => {
        ClinicBusinessDaySettingService.getSetting(
          { clinic_id: clinicId, date: moment(start).format("YYYY-MM-DD") },
          setting => {
            set(clinicDaySetting, setting);
            resolve(setting);
          },
          error => {
            console.error("Error occurred:", error);
            reject(error);
          }
        );
      });
    }

    promiseClinicDaySetting
      .then(data => {
        set(clinicDaySetting, data);
        // クリニック営業時間設定が取得できたら、FullCalendarの設定を更新
        updateCalendarBusinessHours();
      })
      .catch(error => {
        console.error("Error occurred:", error);
      });
  }
};

const updateCalendarBusinessHours = () => {
  if (get(bookingCalendar) && !_.isEmpty(get(clinicDaySetting))) {
    setSlotMinTime();
    setSlotMaxTime();
  }
};

watch(
  () => props.refreshClinicBusinessDaySetting,
  newValue => {
    if (newValue) promiseClinicDaySetting = null;
  }
);

let currentViewType;
const loadUpdateProps = () => {
  if (props.pickedDate.start) {
    currentStartDate.value = props.pickedDate.start;
    scrollToCenter();
  }

  if (isClinicUnaffiliated()) {
    if (currentViewType != props.viewType) {
      promiseClinicDaySetting = null;
      currentViewType = props.viewType;
    }

    loadClinicDaySetting();
    loadDate();
    if (
      props?.viewType &&
      getResourceView(props?.viewType) != get(bookingCalendar)?.getApi().getCurrentData().currentViewType
    ) {
      get(bookingCalendar)?.getApi().changeView(getResourceView(props.viewType));
    }
    if (props?.viewType == BookingViewTypeEnum.Day) {
      get(bookingCalendar)?.getApi()?.setOption("selectConstraint", "businessHours");
      // Day表示の場合、slotDurationも設定する必要がある
      get(bookingCalendar)?.getApi()?.setOption("slotDuration", get(slotDuration));
      get(bookingCalendar)?.getApi()?.setOption("slotLabelInterval", get(slotDuration));
      get(bookingCalendar)?.getApi()?.setOption("snapDuration", get(slotDuration));
    } else {
      get(bookingCalendar)?.getApi()?.setOption("slotDuration", "24:00:00");
      get(bookingCalendar)?.getApi()?.setOption("slotLabelInterval", "24:00:00");
      get(bookingCalendar)?.getApi()?.setOption("selectConstraint", "businessHours");
    }
  } else {
    get(bookingCalendar)?.getApi()?.setOption("slotDuration", props.slotDuration);
    get(bookingCalendar)?.getApi()?.setOption("slotLabelInterval", props.slotDuration);
    get(bookingCalendar)?.getApi()?.setOption("snapDuration", props.slotDuration);
    loadDate();
  }
  setSlotMinTime();
  setSlotMaxTime();
};

const scrollToCenter = () => {
  if (moment(get(currentStartDate)).isSame(moment(), "day")) {
    const timelineHeader = document.querySelector(".fc-timeline-header");
    const nowIndicatorLine = document.querySelector(".fc-timeline-now-indicator-line");
    const headerScroller = document.querySelector(".fc-scrollgrid thead tr:first-child th:last-child .fc-scroller");

    if (!nowIndicatorLine || !headerScroller || !timelineHeader) return;

    const leftDistance = parseInt(window.getComputedStyle(nowIndicatorLine).left, 0);
    const scrollerWidth = timelineHeader.getBoundingClientRect().width;
    headerScroller.scrollLeft = leftDistance - scrollerWidth / 2.5;
  }
};

const setSlotMinTime = () => {
  if (get(bookingCalendar)?.getApi()?.getOption("slotMinTime")?.millisecond == get(slotMinTime).millisecond) return;
  get(bookingCalendar)?.getApi()?.setOption("slotMinTime", get(slotMinTime));
};

const setSlotMaxTime = () => {
  if (get(bookingCalendar)?.getApi()?.getOption("slotMaxTime")?.millisecond == get(slotMaxTime).millisecond) return;
  get(bookingCalendar)?.getApi()?.setOption("slotMaxTime", get(slotMaxTime));
};

const onToggleFreeSpace = () => {
  emits("toggleFreeSpace", showFreeSpaceBooking.value);
};

// フリースペース予約レーン高さ監視のためのMutationObserver
let freeSpaceLaneObserver: MutationObserver | null = null;
const originalHeights = new Map<HTMLElement, number>();

// 通常予約レーン高さ監視のためのMutationObserver
let normalBookingLaneObserver: MutationObserver | null = null;
const normalBookingHeights = new Map<HTMLElement, number>();

// フリースペース予約レーンの高さを監視して、3rem追加する
const setupFreeSpaceLaneHeightObserver = () => {
  // DOM要素が利用可能になるまで待つ
  nextTick(() => {
    const freeSpaceLanes = document.querySelectorAll('td[data-resource-id*="fs"] .fc-timeline-lane-frame');

    if (freeSpaceLanes.length === 0) {
      // フリースペースレーンが見つからない場合、少し待ってから再試行
      setTimeout(() => setupFreeSpaceLaneHeightObserver(), 500);
      return;
    }

    // 各フリースペースレーンの初期高さを記録
    freeSpaceLanes.forEach((lane: HTMLElement) => {
      const computedStyle = window.getComputedStyle(lane);
      const minHeight = parseFloat(computedStyle.minHeight) || 80; // デフォルト5rem = 80px

      // 初期高さを記録（min-heightの値）
      if (!originalHeights.has(lane)) {
        originalHeights.set(lane, minHeight);
      }
    });

    // MutationObserverを設定
    freeSpaceLaneObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === "childList" || mutation.type === "subtree") {
          // イベントが追加/削除された可能性があるので、高さを調整
          adjustFreeSpaceLaneHeights();
        }
      });
    });

    // 各フリースペースレーンとその子要素を監視
    freeSpaceLanes.forEach(lane => {
      freeSpaceLaneObserver?.observe(lane, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style"],
      });
    });

    // 初期の高さ調整を実行
    adjustFreeSpaceLaneHeights();
  });
};

// フリースペース予約レーンの高さを調整する
const adjustFreeSpaceLaneHeights = () => {
  const freeSpaceLanes = document.querySelectorAll('td[data-resource-id*="fs"] .fc-timeline-lane-frame');

  freeSpaceLanes.forEach((lane: HTMLElement) => {
    const events = lane.querySelectorAll(".fc-h-event");
    const originalHeight = originalHeights.get(lane) || 80; // デフォルト5rem = 80px
    let newHeight: number;

    if (events.length > 0) {
      // イベントがある場合、計算された高さ + 3rem (48px) を適用
      const computedHeight = calculateLaneContentHeight(lane);
      newHeight = Math.max(computedHeight + 48, originalHeight);
      lane.style.minHeight = `${newHeight}px`;
    } else {
      // イベントがない場合、元の5remに戻す
      newHeight = originalHeight;
      lane.style.minHeight = `${originalHeight}px`;
    }

    // 対応するヘッダー要素の高さも同期
    adjustCorrespondingHeader(lane, newHeight);
  });
};

// フリースペース予約レーンに対応するヘッダーの高さを調整する
const adjustCorrespondingHeader = (lane: HTMLElement, height: number) => {
  // レーンの親要素（td）からresource-idを取得
  const parentTd = lane.closest('td[data-resource-id*="fs"]');
  if (!parentTd) return;

  const resourceId = parentTd.getAttribute("data-resource-id");
  if (!resourceId) return;

  // 対応するヘッダー要素を探す
  // FullCalendarでは、リソースヘッダーは .fc-datagrid-body 内にあり、
  // 同じ行順序でレーンと対応している
  const allLanes = document.querySelectorAll(".fc-timeline-body td[data-resource-id]");
  const allHeaders = document.querySelectorAll(".fc-datagrid-body tr .fc-datagrid-cell-frame");

  // 現在のレーンが全体の何番目かを特定
  let laneIndex = -1;
  allLanes.forEach((currentLane, index) => {
    if (currentLane.getAttribute("data-resource-id") === resourceId) {
      laneIndex = index;
    }
  });

  // 対応するヘッダー要素の高さを調整
  if (laneIndex >= 0 && laneIndex < allHeaders.length) {
    const correspondingHeader = allHeaders[laneIndex] as HTMLElement;
    if (correspondingHeader) {
      correspondingHeader.style.minHeight = `${height}px`;
      correspondingHeader.style.height = `${height}px`;

      // ヘッダーの親要素（tr）も調整
      const headerRow = correspondingHeader.closest("tr") as HTMLElement;
      if (headerRow) {
        headerRow.style.height = `${height}px`;
      }
    }
  }
};

// レーン内のコンテンツの実際の高さを計算
const calculateLaneContentHeight = (lane: HTMLElement): number => {
  const events = lane.querySelectorAll(".fc-h-event");
  let maxBottom = 0;

  events.forEach((event: HTMLElement) => {
    const rect = event.getBoundingClientRect();
    const laneRect = lane.getBoundingClientRect();
    const relativeBottom = rect.bottom - laneRect.top;
    maxBottom = Math.max(maxBottom, relativeBottom);
  });

  return Math.max(maxBottom, 80); // 最低5rem (80px)
};

// MutationObserverをクリーンアップ
const cleanupFreeSpaceLaneObserver = () => {
  if (freeSpaceLaneObserver) {
    freeSpaceLaneObserver.disconnect();
    freeSpaceLaneObserver = null;
  }
  originalHeights.clear();
};

// 通常予約レーンの高さを監視して、6remに設定する
const setupNormalBookingLaneHeightObserver = () => {
  // DOM要素が利用可能になるまで待つ
  nextTick(() => {
    const normalLanes = document.querySelectorAll(
      'td[data-resource-id]:not([data-resource-id*="fs"]):not([data-resource-id*="fb"]) .fc-timeline-lane-frame'
    );

    if (normalLanes.length === 0) {
      // 通常予約レーンが見つからない場合、少し待ってから再試行
      setTimeout(() => setupNormalBookingLaneHeightObserver(), 500);
      return;
    }

    // 各通常予約レーンの初期高さを記録
    normalLanes.forEach((lane: HTMLElement) => {
      const computedStyle = window.getComputedStyle(lane);
      const minHeight = parseFloat(computedStyle.minHeight) || 144; // デフォルト9rem = 144px

      if (!normalBookingHeights.has(lane)) {
        normalBookingHeights.set(lane, minHeight);
      }
    });

    // 初期の高さ調整を実行
    adjustNormalBookingLaneHeights();

    // MutationObserverを設定
    normalBookingLaneObserver = new MutationObserver(() => {
      // DOM変更があった場合、高さを再調整
      adjustNormalBookingLaneHeights();
    });

    // 各通常予約レーンとその子要素を監視
    normalLanes.forEach(lane => {
      normalBookingLaneObserver?.observe(lane, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style"],
      });
    });
  });
};

// 通常予約レーンの高さを調整する
const adjustNormalBookingLaneHeights = () => {
  const normalLanes = document.querySelectorAll(
    'td[data-resource-id]:not([data-resource-id*="fs"]):not([data-resource-id*="fb"]) .fc-timeline-lane-frame'
  );

  normalLanes.forEach((lane: HTMLElement) => {
    const events = lane.querySelectorAll(".fc-h-event");
    const baseHeight = normalBookingHeights.get(lane) || 144; // デフォルト9rem = 144px
    let newHeight: number;

    if (events.length > 0) {
      // イベントがある場合、コンテンツの実際の高さを計算
      const computedHeight = calculateNormalLaneContentHeight(lane);
      // 基本高さまたは計算された高さ + 余白のうち大きい方を使用
      newHeight = Math.max(computedHeight + 20, baseHeight); // 20pxの余白を追加
    } else {
      // イベントがない場合、基本の9remを使用
      newHeight = baseHeight;
    }

    // レーンの高さを設定
    lane.style.minHeight = `${newHeight}px`;
    lane.style.height = `${newHeight}px`;

    // 対応するヘッダー要素の高さも同期
    adjustNormalBookingHeader(lane, newHeight);
  });
};

// 通常予約レーンに対応するヘッダーの高さを調整する
const adjustNormalBookingHeader = (lane: HTMLElement, height: number) => {
  // レーンの親要素（td）からresource-idを取得
  const parentTd = lane.closest("td[data-resource-id]");
  if (!parentTd) return;

  const resourceId = parentTd.getAttribute("data-resource-id");
  if (!resourceId) return;

  // 対応するヘッダー要素を探す
  const allLanes = document.querySelectorAll(".fc-timeline-body td[data-resource-id]");
  const allHeaders = document.querySelectorAll(".fc-datagrid-body tr .fc-datagrid-cell-frame");

  // 現在のレーンが全体の何番目かを特定
  let laneIndex = -1;
  allLanes.forEach((currentLane, index) => {
    if (currentLane.getAttribute("data-resource-id") === resourceId) {
      laneIndex = index;
    }
  });

  // 対応するヘッダー要素の高さを調整
  if (laneIndex >= 0 && laneIndex < allHeaders.length) {
    const correspondingHeader = allHeaders[laneIndex] as HTMLElement;
    if (correspondingHeader) {
      correspondingHeader.style.minHeight = `${height}px`;
      correspondingHeader.style.height = `${height}px`;

      // ヘッダーの親要素（tr）も調整
      const headerRow = correspondingHeader.closest("tr") as HTMLElement;
      if (headerRow) {
        headerRow.style.height = `${height}px`;
      }
    }
  }
};

// 通常予約レーン内のコンテンツの実際の高さを計算
const calculateNormalLaneContentHeight = (lane: HTMLElement): number => {
  const events = lane.querySelectorAll(".fc-h-event");
  let maxBottom = 0;

  events.forEach((event: HTMLElement) => {
    const rect = event.getBoundingClientRect();
    const laneRect = lane.getBoundingClientRect();
    const relativeBottom = rect.bottom - laneRect.top;
    maxBottom = Math.max(maxBottom, relativeBottom);
  });

  return Math.max(maxBottom, 144); // 最低9rem (144px)
};

// 通常予約レーンのMutationObserverをクリーンアップ
const cleanupNormalBookingLaneObserver = () => {
  if (normalBookingLaneObserver) {
    normalBookingLaneObserver.disconnect();
    normalBookingLaneObserver = null;
  }
  normalBookingHeights.clear();
};

// ライフサイクルフック
onMounted(() => {
  nextTick(() => {
    applyEditableOptions();
  });

  // カレンダーが完全にレンダリングされてからObserverを設定
  nextTick(() => {
    setTimeout(() => {
      setupFreeSpaceLaneHeightObserver();
      setupNormalBookingLaneHeightObserver();
    }, 1000); // カレンダーの初期化を待つ
  });
});

onUnmounted(() => {
  cleanupFreeSpaceLaneObserver();
  cleanupNormalBookingLaneObserver();
});

onUpdated(() => {
  loadUpdateProps();

  // Update showFreeSpaceBooking if props.showFreeSpace changes
  if (props.showFreeSpace !== undefined && showFreeSpaceBooking.value !== props.showFreeSpace) {
    showFreeSpaceBooking.value = props.showFreeSpace;
  }

  // フリースペース表示状態が変更された場合、Observerを再設定
  nextTick(() => {
    if (showFreeSpaceBooking.value) {
      setupFreeSpaceLaneHeightObserver();
    } else {
      cleanupFreeSpaceLaneObserver();
    }
    // 通常予約レーンのObserverも再設定
    setupNormalBookingLaneHeightObserver();
  });
});

// eslint-disable-next-line no-undef
expose({
  loadEvents,
  setTotalCustomersBooked,
  refetchCalendarResources,
  addEventToCalendar: (event: {
    id: string;
    resourceId: string;
    start: Date;
    end: Date;
    extendedProps?: Record<string, unknown>;
  }) => get(bookingCalendar)?.getApi().addEvent(event),
  adjustFreeSpaceLaneHeights,
  setupFreeSpaceLaneHeightObserver,
  cleanupFreeSpaceLaneObserver,
  adjustCorrespondingHeader,
  adjustNormalBookingLaneHeights,
  setupNormalBookingLaneHeightObserver,
  cleanupNormalBookingLaneObserver,
});

return (_ctx: any,_cache: any) => {
  const _component_VTooltip = _resolveComponent("VTooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BookingStatusColorOptions), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "d-flex align-items-center mr-3"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([item.colorClass, "mr-2 circle"])
              }, null, 2),
              _createElementVNode("p", _hoisted_4, _toDisplayString(item.name), 1)
            ]))
          }), 128))
        ])
      ]),
      (_unref(isShowFreeSpaceEnabledInSettings))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(Checkbox), {
              modelValue: showFreeSpaceBooking.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showFreeSpaceBooking).value = $event)),
              inputId: "show_free_space",
              name: "show_free_space",
              binary: true,
              onChange: onToggleFreeSpace
            }, null, 8, ["modelValue"]),
            _hoisted_6
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["booking-calendar__body", { 'wrapper-week-view': __props.viewType == 'Week', 'clinic-affiliated': !isClinicUnaffiliated() }])
    }, [
      _createVNode(_unref(FullCalendar), {
        ref_key: "bookingCalendar",
        ref: bookingCalendar,
        options: calendarOptions.value
      }, {
        slotLabelContent: _withCtx(({ date }) => [
          (__props.viewType == 'Week')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(moment)(date).format("D")), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(dayOfWeekShort)[_unref(moment)(date).format("dddd")]), 1)
                ]),
                (_unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Unaffiliated)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, " 予約人数 " + _toDisplayString(totalCustomersBooked.value[_unref(moment)(date).format("D")] || 0), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(Timeline, {
                  date: date,
                  viewType: __props.viewType
                }, null, 8, ["date", "viewType"]),
                (
              __props.viewType == _unref(BookingViewTypeEnum).Day &&
              _unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Unaffiliated
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, " 空き枠 " + _toDisplayString(props.remainingSlots.find(slot => slot["start"] == _unref(moment)(date).format("H:m"))?.amount || 0), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        eventContent: _withCtx(({ event }) => [
          (__props.viewType == _unref(BookingViewTypeEnum).Day)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_VTooltip, { distance: 10 }, {
                  popper: _withCtx(() => [
                    (__props.viewType == _unref(BookingViewTypeEnum).Day)
                      ? (_openBlock(), _createBlock(EventTooltipTemplate, {
                          key: 0,
                          event: event
                        }, null, 8, ["event"]))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    (__props.viewType == _unref(BookingViewTypeEnum).Day)
                      ? (_openBlock(), _createBlock(DayEventTemplate, {
                          key: 0,
                          event: event
                        }, null, 8, ["event"]))
                      : (_openBlock(), _createBlock(WeekEventTemplate, {
                          key: 1,
                          event: event
                        }, null, 8, ["event"]))
                  ]),
                  _: 2
                }, 1024)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (__props.viewType == _unref(BookingViewTypeEnum).Day)
                  ? (_openBlock(), _createBlock(DayEventTemplate, {
                      key: 0,
                      event: event
                    }, null, 8, ["event"]))
                  : (_openBlock(), _createBlock(WeekEventTemplate, {
                      key: 1,
                      event: event
                    }, null, 8, ["event"]))
              ]))
        ]),
        _: 1
      }, 8, ["options"])
    ], 2)
  ], 64))
}
}

})